'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LiveCatalogStatusRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = function transform(body) {
    var _body$data = body.data,
        approved = _body$data.Approved,
        description = _body$data.AuctionDescription,
        catalogId = _body$data.AuctionId,
        title = _body$data.AuctionTitle,
        currentItem = _body$data.CurrentLot,
        lastUpdated = _body$data.LastUpdated,
        itemCount = _body$data.LotCount;

    var _ref = currentItem || {},
        itemId = _ref.LotId,
        lotNumber = _ref.LotNumber,
        lotTitle = _ref.LotTitle,
        lotDescription = _ref.LotDescription,
        askPrice = _ref.AskPrice,
        leadingBidder = _ref.LeadingBidderId,
        lowEstimate = _ref.LowEstimate,
        leadingBid = _ref.HighBid,
        highEstimate = _ref.HighEstimate,
        reserverPrice = _ref.ReservePrice;

    return {
        data: {
            approved: approved,
            catalogId: catalogId,
            currentItem: {
                askPrice: askPrice,
                highEstimate: highEstimate,
                itemId: itemId,
                leadingBid: leadingBid,
                leadingBidder: leadingBidder,
                lotDescription: lotDescription,
                lotNumber: lotNumber,
                lotTitle: lotTitle,
                lowEstimate: lowEstimate,
                reserverPrice: reserverPrice
            },
            description: description,
            itemCount: itemCount,
            lastUpdated: lastUpdated,
            status: !!currentItem.LotId ? 'live' : 'online',
            title: title
        }
    };
};

var LiveCatalogStatusRemote = exports.LiveCatalogStatusRemote = {
    fetchLiveCatalogStatus: function fetchLiveCatalogStatus(_ref2) {
        var Token = _ref2.authToken,
            bidderId = _ref2.bidderId,
            AuctionId = _ref2.catalogId,
            deployment = _ref2.deployment,
            Email = _ref2.Email;
        return new _promise2.default(function (resolve, reject) {
            var requestFuction = !!bidderId && !!Email ? _helpers.makePost : _helpers.makeGet;
            var request = requestFuction('<CLERK-SERVICE>clerk/auction/' + AuctionId, deployment);

            if (bidderId && Email) {
                (0, _helpers.addAuthToken)(request, Token);
                request.send({
                    AuctionId: AuctionId,
                    Email: Email,
                    Token: Token
                });
            }

            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, success404: true, transform: transform });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/liveCatalogStatus.js
// module id = grTh
// module chunks = 57